import { Component, Input } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

/**
 * Self-contained, view-only modal: shows an entity's images with no upload
 * or delete affordances.
 * Usage: bsModalService.show(CoreImageListModalComponent, { initialState: { entityType, entityId, title } })
 */
@Component({
  selector: 'app-core-image-list-modal',
  templateUrl: './core-image-list-modal.component.html'
})
export class CoreImageListModalComponent {
  @Input() entityType = '';
  @Input() entityId = 0;
  @Input() title = '';

  constructor(public bsModalRef: BsModalRef) {}

  dismiss(): void {
    this.bsModalRef.hide();
  }
}
